var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "default-holder" }, [
    _c("div", { staticClass: "img-abstract" }, [
      _c("img", { attrs: { src: _vm.document.imageLink } })
    ]),
    _c("p", { staticClass: "small-heading" }, [
      _vm._v(_vm._s(_vm.document.subText))
    ]),
    _vm.document.downloadDocName !== ""
      ? _c(
          "a",
          {
            attrs: {
              href: "" + _vm.document.downloadLink,
              download: "" + _vm.document.downloadDocName
            }
          },
          [
            _c("button", { staticClass: "btn btn--inverse" }, [
              _vm._v("Download")
            ])
          ]
        )
      : _vm._e(),
    _vm.document.downloadDocName === "" &&
    _vm.document.downloadLink.includes("http")
      ? _c(
          "a",
          { attrs: { href: "" + _vm.document.downloadLink, target: "_blank" } },
          [
            _c("button", { staticClass: "btn btn--inverse" }, [
              _vm._v("Go to link")
            ])
          ]
        )
      : _vm._e(),
    _vm.document.downloadDocName === "" &&
    !_vm.document.downloadLink.includes("http")
      ? _c("a", { attrs: { href: "" + _vm.document.downloadLink } }, [
          _c("button", { staticClass: "btn btn--inverse" }, [
            _vm._v("Go to link")
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }